import { Type, optional } from 'specified';
import { isoDateSpec } from '../../specs-utils.js';

const prescriptionContentSpec = Type.interface({
    power: Type.string,
    baseCurve: Type.string,
    diameter: Type.string,
    cylinder: optional(Type.string),
    axis: optional(Type.string),
    addition: optional(Type.string),
    productId: optional(Type.string)
});
const prescriptionSpec = Type.interface({
    id: Type.string,
    name: Type.string,
    issueDate: isoDateSpec,
    expiryDate: isoDateSpec,
    storeName: Type.string,
    storeId: optional(Type.string),
    recommendedNextEyeTestDate: optional(isoDateSpec),
    validityStatus: Type.literal({
        VALID: 1,
        INVALID: 1
    }),
    leftEye: prescriptionContentSpec,
    rightEye: prescriptionContentSpec
});
const prescriptionsListSpec = Type.array(prescriptionSpec);

export { prescriptionContentSpec, prescriptionSpec, prescriptionsListSpec };
//# sourceMappingURL=specs.js.map
